export const types = {
  MAKE_ASSEMBLY_MODAL_OPEN:
    'modules/quotes/quoteItems/modals/makeAssemblyModal/MAKE_ASSEMBLY_MODAL_OPEN',
  MAKE_ASSEMBLY_MODAL_CLOSE:
    'modules/quotes/quoteItems/modals/makeAssemblyModal/MAKE_ASSEMBLY_MODAL_CLOSE',
  MAKE_ASSEMBLY_MODAL_CONFIRM:
    'modules/quotes/quoteItems/modals/makeAssemblyModal/MAKE_ASSEMBLY_MODAL_CONFIRM',
};

export const makeAssemblyModal = {
  open: ({ shouldAskAboutOps, shouldAskAboutMakeSupportingFile }) => ({
    type: types.MAKE_ASSEMBLY_MODAL_OPEN,
    payload: { shouldAskAboutOps, shouldAskAboutMakeSupportingFile },
  }),
  close: () => ({
    type: types.MAKE_ASSEMBLY_MODAL_CLOSE,
  }),
  confirm: ({
    shouldRegenerateOps,
    shouldMakeSupportingFileIfHasGeometry,
  }) => ({
    type: types.MAKE_ASSEMBLY_MODAL_CONFIRM,
    payload: { shouldRegenerateOps, shouldMakeSupportingFileIfHasGeometry },
  }),
};
